import { render, staticRenderFns } from "./GroupBookingDetails.vue?vue&type=template&id=2ece2dfa&scoped=true&"
import script from "./GroupBookingDetails.vue?vue&type=script&lang=js&"
export * from "./GroupBookingDetails.vue?vue&type=script&lang=js&"
import style0 from "./GroupBookingDetails.vue?vue&type=style&index=0&id=2ece2dfa&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ece2dfa",
  null
  
)

export default component.exports